<template>
  <div class="zj-iframe-container">
    <iframe
      class="zj-iframe"
      :src="url"
      scrolling="auto"
      frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  name: 'ZjIframe',
  props: {
    url: [String, Function]
  }
}
</script>
